import { useMsal } from "@azure/msal-react";

/**
 * The signed-in person's display name, used to show "Last modified by" right after a
 * save (the server records the real value from the token). Falls back to the
 * placeholder the screen has always sent.
 */
export function useCurrentUserName(): string {
  const { instance, accounts } = useMsal();
  const account = instance.getActiveAccount() ?? accounts[0];
  return account?.name || account?.username || "currentUser";
}

export default useCurrentUserName;
